import { jsx as d } from "react/jsx-runtime";
import { noop as e } from "es-toolkit/function";
import t from "../../utils/classNames.js";
const m = ({ onClick: a = e, makeBackdropVisible: r = !1, className: o = "" }) => {
  const s = t("SidebarBackdrop", r && "sidebar-backdrop-bg", o);
  return /* @__PURE__ */ d("div", { className: s, onClick: a, "data-testid": "sidebarBackdrop" });
};
export {
  m as default
};
//# sourceMappingURL=SidebarBackdrop.js.map
